import React, { useEffect, useState, useCallback } from "react";

import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

// @YUp
import { Button, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Visibility from "@mui/icons-material/Visibility";
import API from "../../utils/Axios.utils";
import useAuth from "../../hooks/useAuth";

const ViewCandidate = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const candidateDetails = location.state?.CandidateDetails;

  const [fileUrl, setFileUrl] = useState("");

  const navigateToPreviousPage = () => {
    navigate(-1);
  };

  const { token, user: userDetails } = useAuth();
  const getPdfUrl = useCallback(async () => {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const data = {
      supplierId: userDetails?.supplierId,
      coreSkillId: candidateDetails?.coreSkillId,
      job_code: candidateDetails?.job_code,
      email: candidateDetails?.email,
    };

    let url = `/api/profile/candidate_document`;

    try {
      const res = await API.post(url, data, config);
      setFileUrl(res?.data?.url);
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  }, [token, userDetails?.supplierId, candidateDetails]);

  useEffect(() => {
    getPdfUrl();
  }, [getPdfUrl]);

  return (
    <div style={{ marginTop: 20 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
        Back
      </Button>
      <div
        style={{
          border: "1px solid #989898",
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontWeight: "500",
            letterSpacing: 1,
            textAlign: "left",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 550,
            }}
          >
            View Profile
          </span>
          <div style={{ display: "grid" }}>
            <Grid container spacing={2}>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Job Code
                </span>
                <div>{candidateDetails?.job_code || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Candidate Name
                </span>
                <div>{candidateDetails?.candidate_name || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Current Address
                </span>
                <div>
                  {candidateDetails?.candidate_current_location || null}
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Mobile
                </span>
                <div>{candidateDetails?.mobile || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Email</span>
                <div>{candidateDetails?.email || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Currency
                </span>
                <div>{candidateDetails?.currency || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Budget
                </span>
                <div>{candidateDetails?.budget || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Budget EOM
                </span>
                <div>{candidateDetails?.budget_eom || null}</div>
              </Grid>
              {candidateDetails?.start_date && candidateDetails?.end_date ? (
                <>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px", fontWeight: 600 }}>
                      Project Start Date
                    </span>
                    <div>{candidateDetails.start_date}</div>
                  </Grid>

                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px", fontWeight: 600 }}>
                      Project End Date
                    </span>
                    <div>{candidateDetails.end_date}</div>
                  </Grid>
                </>
              ) : null}

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Notes (Optional)
                </span>
                <div>{candidateDetails?.important_note || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  View Profile
                </span>
                <div>
                  <Button
                    variant="contained"
                    aria-haspopup="true"
                    style={{
                      background: "#2777AA",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    }}
                    startIcon={<Visibility />}
                    onClick={() => {
                      navigate("/candidate_data/viewFile", {
                        state: { fileUrl },
                      });
                    }}
                  >
                    View Profile
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCandidate;
